import useGetStores from './useGetStores'

export default useGetStores
